import React from 'react';
import { showDialog } from '../../actions/dialog';
import { connect } from 'react-redux';
import Logger from '../../util/Logger';
import './EventDetailHeader.css';
import Collection from '../../models/Collection';
import Event from '../../models/Event';
import User from '../../models/User';
import { UserAvatar } from '../shared/UserAvatar';
import '../shared/UserAvatar.css';
import DateTime from '../../models/DateTime';
import { TopBarVisibility } from '../layout/TopBarVisibility';
import CoverImage from '../../images/creator_report_cover.svg';
import queryString from 'stringquery';
import Media from '../../models/Media';
import PresentMode from '../../images/presentation-icon-black.png';
import Tooltip from '../shared/Tooltip';
import { NavigationUtils } from '../../util/NavigationUtils';
import { PresentationPageAnalytics } from '../../analytics/PresentationPageAnalytics';
import { TrackingAnalytics } from '../../analytics/TrackingAnalytics';
import { ScreenRecorder } from '../../util/ScreenRecorder';
import { EventQuestionType } from '../../models/EventQuestionType'
import FeatureRequestDialog from '../shared/FeatureRequestDialog';

class EventDetailHeader extends React.Component {

  constructor (props) {
    super(props);

    const { user } = props;
    if (!user) {
      Logger.assert('Missing user in EventDetailHeader component');
    }
  }

  handleLaunchVideoClicked = ($event) => {
    $event.preventDefault();

    const { event, showDialog } = this.props;
    if (!!event) {
      const launchMedia = Event.getLaunchMedia(event);
      if (!!launchMedia) {
        const video = Media.getVideoUrl(launchMedia);
        if (!!video) {
          showDialog({
            body: (
              <div className="h-100 w-100">
                <video
                  className="h-100 w-100"
                  controls={ true }
                  preload="auto"
                  src={ video }
                />
              </div>
            ),
            cancel: 'Cancel'
          });
        } else {
          const photo = Media.getPhotoUrl(launchMedia);
          if (!!photo) {
            showDialog({
              body: (
                <div className="h-100 w-100">
                  <img className="h-100 w-100" src={ photo } alt="Event Media" />
                </div>
              ),
              cancel: 'Cancel'
            });
          }
        }
      }
    }
  };

  enterPresentationMode = () => {
    PresentationPageAnalytics.enterPresentationView();
    ScreenRecorder.trackCustomAction('PRESENT_VIEW_ENTERED');
    TrackingAnalytics.gtag('Present', {
      event_id: Event.getId(this.props.event)
    });
    NavigationUtils.openTab('present');
  };

  render () {
    const { location, user, editing, event, collection } = this.props;
    const isViewingAs = TopBarVisibility.isViewingAs(user);
    const isShowingHeroRibbon = TopBarVisibility.isShowingHeroRibbon(event);
    const isShowingConcurrentSwitcher = TopBarVisibility.isShowingConcurrentSwitcher(event,
      collection);
    const tenantName = User.hasTenant(user) ? User.getTenant(user).name : null;
    // Figure out the offset dynamically based on page content
    let offsetClass = '';
    if (isViewingAs) {
      offsetClass = 'viewing-as-and-';
      if (isShowingHeroRibbon && isShowingConcurrentSwitcher) {
        offsetClass += 'hero-ribbon-and-concurrent-switcher-offset';
      } else if (isShowingHeroRibbon) {
        offsetClass += 'hero-ribbon-offset';
      } else if (isShowingConcurrentSwitcher) {
        offsetClass += 'concurrent-switcher-offset';
      } else {
        offsetClass = '';
      }
    } else {
      if (isShowingHeroRibbon && isShowingConcurrentSwitcher) {
        offsetClass += 'hero-ribbon-and-concurrent-switcher-offset';
      } else if (isShowingHeroRibbon) {
        offsetClass += 'hero-ribbon-offset';
      } else if (isShowingConcurrentSwitcher) {
        offsetClass += 'concurrent-switcher-offset';
      } else {
        offsetClass = '';
      }
    }

    // No offset when editing mode
    if (!!editing) {
      offsetClass = '';
    }

    let title = collection ? Collection.getName(collection) : null;
    if (!title) {
      title = event ? Event.getTitle(event) : null;
    }
    const content = event ? Event.getName(event) : null;
    const startDate = event ? Event.getStartTime(event) : null;
    const endDate = event ? Event.getEndTime(event) : null;

    let headerClass = 'whiteout';
    if (event) {
      if (Event.isClosed(event)) {
        headerClass = 'event-detail-header-completed';
        if (User.isGuest(user)) {
          offsetClass += ' guest-offset';
        }
      } else {
        headerClass = 'event-detail-header';
      }
    }

    let coloring = 'whiteout';
    if (!!event) {
      if (Event.isClosed(event)) {
        coloring = 'whiteout';
      } else {
        coloring = 'greenout';
      }
    }

    let tz = DateTime.getCurrentTimeZone();
    if (!!location.search) {
      const searchParams = queryString(location.search);
      if (!!searchParams.tz) {
        tz = decodeURIComponent(searchParams.tz);
        Logger.info('tz passed from URL:', tz);
      }
    } else {
      Logger.info('Using current time zone:', tz);
    }

    const now = DateTime.applyTimeZone(DateTime.now(), tz);
    const zone = now.zoneAbbr();
    // Don't touch the formatting on this string or the visual spacing gets all messed up.
    const reportGeneratedDate = `${DateTime.format(now, 'MMM DD, YYYY', tz)} at ${DateTime.format(
      now, 'hh:mm A', tz)} ${zone}`;

    // Get the launch media
    const launchMedia = event ? Event.getLaunchMedia(event) : null;

    let questionIndex = -1;
    let questionTotal = -1;

    if (!!collection && !!event) {
      questionTotal = Collection.getEvents(collection).length;
      questionIndex = TopBarVisibility.getConcurrentBarCurrentIndex(event, collection);
    }

    return (
      <div className={ `event-header ${offsetClass}` }>
        <div
          className={ `${headerClass}` }
          style={ { backgroundImage: `url(${CoverImage})` } }>
          <div className={ `${coloring}` }>
            <div className="container">
              <div className="content">
                { !!event && (
                  <div className="col text-left py-4">
                    <div className="row no-gutters d-print-none">
                      <div className="col">
                        <div className="list-item row no-gutters mb-3">
                          <UserAvatar user={ Event.getHero(event) } simple={ true } />
                          <div className="popin-creator ml-3">
                            { User.getDisplayName(Event.getHero(event)) }
                            &nbsp;
                            { Event.getTenantName(event) !== tenantName && `at ${Event.getTenantName(event)}` }
                          </div>
                        </div>
                      </div>
                      {/* removed by akmal || EventQuestionType.isStackRankType(event.question_type) */}
                      {/* !(EventQuestionType.isMultipleRatingType(event.question_type) ) && */}
                      { User.isLiveEnabled(user) && (
                        <div>
                        { 
                          <Tooltip tooltip="Enter Live View">
                            <button
                              className="btn present-btn"
                              onClick={ this.enterPresentationMode }>
                              <div className="row no-gutters m-auto">
                                <img
                                  src={ PresentMode }
                                  width="24"
                                  height="24"
                                  className="m-auto"
                                  alt="Live View" />
                                <div className="ml-2 my-auto">Live View</div>
                              </div>
                            </button>
                          </Tooltip>
                        }
                        {/* { (EventQuestionType.isMultipleRatingType(event.question_type) || EventQuestionType.isStackRankType(event.question_type)) &&
                          <>
                            <button type="button" className="btn present-btn" data-toggle="modal" data-target="#liveView">
                              <div className="row no-gutters m-auto">
                                <img
                                  src={ PresentMode }
                                  width="24"
                                  height="24"
                                  className="m-auto"
                                  alt="Live View" />
                                <div className="ml-2 my-auto">Live View</div>
                              </div>
                            </button>
                            <FeatureRequestDialog id="liveView"/>
                          </>
                        } */}
                        </div>
                      ) }
                    </div>

                    <div className="row no-gutters">
                      { /* Launch Video */ }
                      { !!launchMedia && (
                        <div className="col-2 d-print-none">

                          <div className="launch-video-container my-auto mr-auto">
                            <img
                              onClick={ this.handleLaunchVideoClicked }
                              className="launch-video clickable"
                              align="center center"
                              src={ Media.getThumbnailUrl(launchMedia) || Media.getPhotoUrl(launchMedia) }
                              alt="Lauch Media" />
                          </div>

                          <div className="d-flex mt-2" onClick={ this.handleLaunchVideoClicked }>
                            <div className="play-launch-video p-2 text-center my-auto mr-auto font-size-sm">
                              { Media.getThumbnailUrl(launchMedia) ? 'Play Intro Video' : 'Show Image' }
                            </div>
                          </div>
                        </div>
                      ) }
                      <div className="col super-hack-incoming">
                        <div className="hide-your-kids-hide-your-wife">
                          { !!title && <div className="popin-title">{ title }</div> }
                          { (questionIndex >= 0 && questionTotal >= 0) && (
                            // popin-date class since the title is the same style as the date text
                            <div className="d-none d-print-block popin-date">
                              Question { questionIndex + 1 } of { questionTotal }
                            </div>
                          ) }
                          { !!content && (
                            <div
                              className={ `popin-content ${!!title
                                ? 'mb-3'
                                : 'my-3'}` }>{ content }</div>
                          ) }
                          { (!!startDate && !!endDate) && (
                            <div className="row no-gutters h-100">
                              <i className="material-icons my-auto d-print-none">access_time</i>
                              <div className="popin-date my-auto">
                                { DateTime.format(startDate, 'MMM DD, YYYY') }
                                &nbsp;-&nbsp;
                                { DateTime.format(endDate, 'MMM DD, YYYY') }
                              </div>
                              <div className="my-auto">
                                { Event.isOpen(event) && (
                                  <div className="pill-active d-print-none">
                                    ACTIVE
                                  </div>
                                ) }
                                { Event.isUpcoming(event) && (
                                  <div className="pill-upcoming d-print-none">
                                    UPCOMING
                                  </div>
                                ) }
                              </div>
                            </div>
                          ) }
                        </div>
                      </div>
                    </div>
                  </div>
                ) }
              </div>
            </div>
          </div>

          { !!event && (
            <div className="row no-gutters d-none d-print-block">
              <div className="col-4 popin-creator-print">
                <div className="popin-creator-print-content text-truncate">
                  { User.getDisplayName(Event.getHero(event)) }
                </div>
                <div className="popin-creator-print-content text-truncate">
                  { Event.getTenantName(event) }
                </div>
                <div className="popin-report-date text-truncate">
                  Exported { reportGeneratedDate }
                </div>
              </div>

              <div className="col-8" />
            </div>
          ) }

        </div>
      </div>
    );
  }

}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    event: state.event.event
  };
};

export default connect(mapStateToProps, { showDialog })(EventDetailHeader);
